"use client";

import type { ReactNode } from "react";

interface TabButtonProps {
  id: string;
  panelId: string;
  active: boolean;
  onSelect: () => void;
  children: ReactNode;
}

/**
 * A single tab in the "Quoi de neuf" popin header. Real `role="tab"` wired to
 * its panel for screen readers; arrow-key navigation is handled by the parent
 * tablist via `onKeyDown`.
 */
export function TabButton({ id, panelId, active, onSelect, children }: TabButtonProps) {
  return (
    <button
      type="button"
      role="tab"
      id={id}
      aria-selected={active}
      aria-controls={panelId}
      tabIndex={active ? 0 : -1}
      onClick={onSelect}
      className="relative flex-1 sm:flex-none h-9 px-3.5 rounded-lg text-[13px] font-medium transition-colors duration-150 cursor-pointer focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent"
      style={{
        color: active ? "var(--color-text-primary)" : "var(--color-text-muted)",
        backgroundColor: active ? "var(--color-accent-subtle)" : "transparent",
      }}
    >
      {children}
      {active && (
        <span
          aria-hidden="true"
          className="absolute left-3 right-3 h-[2px] rounded-full"
          style={{ bottom: "-1px", background: "var(--color-accent)" }}
        />
      )}
    </button>
  );
}
